(() => {
  const selector = '.footer-gallery.carousel-slider';
  const nativeClass = 'footer-gallery-native';
  const nativeTimers = new WeakMap();
  const options = {
    rows: 0,
    slidesToShow: 3,
    autoplay: true,
    autoplaySpeed: 2500,
    slidesToScroll: 1,
    speed: 500,
    arrows: false,
    pauseOnFocus: false,
    pauseOnHover: false,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          adaptiveHeight: true,
        },
      },
    ],
  };

  const getJQuery = () => window.jQuery || window.$;

  const getSlidesPerView = () => {
    if (window.matchMedia('(max-width: 767px)').matches) return 1;
    if (window.matchMedia('(max-width: 1023px)').matches) return 2;
    return 3;
  };

  const findGalleries = (root = document) => {
    const galleries = [];

    if (root instanceof Element && root.matches(selector)) {
      galleries.push(root);
    }

    root.querySelectorAll?.(selector).forEach((gallery) => {
      galleries.push(gallery);
    });

    return galleries;
  };

  const getNativeSlides = (gallery) => {
    return [...gallery.children].filter((child) => child.classList.contains('img-slide'));
  };

  const stopNativeGallery = (gallery) => {
    const timer = nativeTimers.get(gallery);

    if (timer) {
      window.clearInterval(timer);
      nativeTimers.delete(gallery);
    }

    gallery.classList.remove(nativeClass);
    gallery.style.removeProperty('--footer-gallery-index');
    delete gallery.dataset.footerGalleryIndex;
  };

  const updateNativeGallery = (gallery, index = Number(gallery.dataset.footerGalleryIndex || 0)) => {
    const slides = getNativeSlides(gallery);
    const maxIndex = Math.max(slides.length - getSlidesPerView(), 0);
    const nextIndex = maxIndex > 0 ? Math.min(index, maxIndex) : 0;

    gallery.dataset.footerGalleryIndex = String(nextIndex);
    gallery.style.setProperty('--footer-gallery-index', nextIndex);
  };

  const startNativeGallery = (gallery) => {
    stopNativeGallery(gallery);
    gallery.classList.add(nativeClass);
    updateNativeGallery(gallery);

    if (getNativeSlides(gallery).length <= getSlidesPerView()) {
      return;
    }

    nativeTimers.set(
      gallery,
      window.setInterval(() => {
        if (!document.body.contains(gallery)) {
          stopNativeGallery(gallery);
          return;
        }

        const slides = getNativeSlides(gallery);
        const maxIndex = Math.max(slides.length - getSlidesPerView(), 0);
        const currentIndex = Number(gallery.dataset.footerGalleryIndex || 0);
        const nextIndex = maxIndex > 0 && currentIndex < maxIndex ? currentIndex + 1 : 0;

        updateNativeGallery(gallery, nextIndex);
      }, options.autoplaySpeed)
    );
  };

  const initGallery = (gallery) => {
    const $ = getJQuery();

    if (gallery.classList.contains('slick-initialized')) {
      stopNativeGallery(gallery);

      if ($?.fn?.slick) {
        $(gallery).slick('setPosition');
        $(gallery).slick('slickPlay');
      }

      return;
    }

    if (!$?.fn?.slick) {
      startNativeGallery(gallery);
      return;
    }

    stopNativeGallery(gallery);
    $(gallery).slick(options);
  };

  const initGalleries = (root = document) => {
    findGalleries(root).forEach(initGallery);
  };

  const refreshGalleries = (root = document) => {
    window.requestAnimationFrame(() => initGalleries(root));
  };

  window.addEventListener('load', () => refreshGalleries());

  document.addEventListener('shopify:section:load', (event) => {
    refreshGalleries(event.target);
  });

  document.addEventListener('shopify:block:select', (event) => {
    const gallery = event.target.closest?.(selector);

    if (gallery) {
      refreshGalleries(gallery);
    }
  });

  window.addEventListener('resize', () => {
    findGalleries().forEach((gallery) => {
      if (gallery.classList.contains(nativeClass)) {
        updateNativeGallery(gallery);
      }
    });
  });
})();
